import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import {
  SortableContainer,
  sortableElement,
  sortableHandle
} from 'react-sortable-hoc';
import {
  Button,
  AppBar,
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  Icon,
  Box
} from '@mui/material';
import { Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { DragIndicator, ArrowUpward, ExpandMore } from '@mui/icons-material';
import { api } from '../../api/instance';
import Blockform from './Blockform';
import Loader from '../../components/Loader/Loader';

const Blocks = () => {
  const [blocks, setBlocks] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [validForm, setValidForm] = useState(false);

  useEffect(() => {
    const getBlocks = async () => {
      try {
        const response = await api.get('/blocks');
        if (response.status === 200) {
          setBlocks(response.data.blocks);
        }
      } catch (error) { }
    };
    getBlocks();
  }, []);

  const saveBlocks = async () => {
    setSubmitting(true);
    try {
      console.log('BLOCKS', blocks)
      const response = await api.post('/blocks', blocks);
      if (response.status === 200) {
        console.log('Blocks updated');
        setSubmitting(false);
      }
    } catch (error) {
      console.log('Blocks did not update', error)
      setSubmitting(false);
    }
  };

  const formSubmit = () => { };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setBlocks((prevItems) => {
      const newItems = Array.from(prevItems);
      newItems.splice(newIndex, 0, newItems.splice(oldIndex, 1)[0]);
      return newItems;
    });
  };

  let componentData;

  const ItemFormCreate = (
    <form
      id="createForm"
      className="cell margin-top-2x"
      onSubmit={formSubmit}
      encType="multipart/form-data"
      ref={(el) => (this.form = el)}
    >
      <h3>ADD BLOCK</h3>
      <div className="cell padding-all white-bg round-medium margin-top">
        <label htmlFor="order">Order</label>
        <input
          type="number"
          name="order"
          onChange={e => setBlocks({ ...blocks, order: e.target.value })}
          value={blocks?.length}
          readOnly
        />
        <label htmlFor="name">Block Name</label>
        <input
          type="text"
          name="name"
          id="name"
          onChange={e => setBlocks({ ...blocks, name: e.target.value })}
        />
        <Tooltip title={submitting ? 'Saving' : 'Save'} placement="top">
          <Button fontSize="small" onClick={() => this.clickSubmit()} style={{ flex: 1 }} color="primary" aria-label="Menu">
            {submitting ? 'Saving' : 'Save Block'}
          </Button>
        </Tooltip>
      </div>
      {validForm ? '' : 'FORM MISSING'}
    </form>
  );

  const DragHandle = sortableHandle(() => (
    <Icon>
      <DragIndicator />
    </Icon>
  ));

  const SortableItem = sortableElement(({ item }) => (
    <Accordion key={item.order}>
      <AccordionSummary className="grid-x" expandIcon={<ExpandMore />}>
        <DragHandle />
        <Typography className="f-16" style={{ marginLeft: 20, verticalAlign: 'middle', paddingTop: 5 }}>
          {item.name}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <img src={item.image} alt={item.name} width="100%" />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Blockform item={item} blocks={blocks} setBlocks={setBlocks} />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  ));

  const SortableList = SortableContainer(() => {
    return (
      <Grid item style={{
        marginBottom: '5rem'
      }}>
        {blocks?.map((items, index) => (
          <SortableItem key={`item-${index}`} index={index} item={items} />
        ))}
      </Grid >
    );
  });

  if (blocks) {
    componentData = (
      <>
        <Grid container spacing={2}>
          <Grid item>
            <Typography variant="body1" gutterBottom>These are the block grid that displays in the home page of the site, here you can update their information and order by dragging them.</Typography>
          </Grid>
          <SortableList onSortEnd={onSortEnd} useDragHandle />
          {blocks.length >= 7 ? "" : ItemFormCreate}
        </Grid>
        <AppBar position="fixed" color="default" sx={{ top: 'auto', bottom: 0 }}>
          <Toolbar>
            <div className="right" style={{ flexGrow: 1 }}>
              <Tooltip title={submitting ? "Saving" : "Save"} placement="top">
                <Button fontSize="small"
                  onClick={() => saveBlocks()}
                  style={{ flex: 1 }}
                  color="primary"
                  aria-label="Menu">
                  {submitting ? "Saving.." : "Update Blocks"}
                </Button>
              </Tooltip>
            </div>
          </Toolbar>
        </AppBar>
      </>
    )
  } else {
    componentData = <Loader />
  }//CHECK IF SETTINGS LOADED


  return (
    <Box>
      <Grid item xs={12}>
        {componentData}
      </Grid>
    </Box>
  )
};

export default Blocks;
